import { useCallback, useContext, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { ModalContext } from 'components/ModalProvider/ModalProvider';
import { actions } from 'features/users/redux';

const useCreateAgent = (isMobile = false) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { openModal, closeModal } = useContext(ModalContext);

  const [form, setForm] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    name: '',
    surname: '',
    commission: 1,
  });

  const [withdrawalAllowed, setWithdrawalAllowed] = useState(true);
  const [depositAllowed, setDepositAllowed] = useState(true);
  const [onlyPlayerCreationAllowed, setOnlyPlayerCreationAllowed] = useState(false);
  const [semiAutomaticPayment, setSemiAutomaticPayment] = useState(false);

  const formData = useMemo(() => {
    const commission = form.commission || 0;

    return { ...form, withdrawalAllowed, onlyPlayerCreationAllowed, depositAllowed, commission, semiAutomaticPayment };
  }, [form, withdrawalAllowed, onlyPlayerCreationAllowed, depositAllowed, semiAutomaticPayment]);

  const onSubmit = useCallback(
    e => {
      if (e) e.preventDefault();

      if (!isMobile) closeModal();

      dispatch(
        actions.createAgent({
          form: formData,
          callback: () => history.push('/users/all'),
        }),
      );
    },
    [dispatch, formData, isMobile],
  );

  const changeValue = useCallback(
    e => {
      setForm({ ...form, [e.currentTarget.name]: e.currentTarget.value?.trim() });
    },
    [form],
  );

  const changeValueMultiple = (updates) => {
    setForm((prev) => ({ ...prev, ...updates }));
  };

  const changeValueUsername = useCallback(
    e => {
      setForm({ ...form, username: e.currentTarget.value?.replace(/\s/g, '') });
    },
    [form],
  );
  const changeCommission = useCallback(
    e => {
      const value = e.currentTarget.value?.trim();
      const reg = /^[1-9][0-9]*$/;
      if ((reg.test(value) || !value.length) && value <= 100) {
        setForm({ ...form, commission: e.currentTarget.value?.trim() });
      }
    },
    [form],
  );

  const disabled = form.confirmPassword !== form.password || form.username.length === 0 || form.password.length === 0;

  return {
    output: {
      form,
      disabled,
      withdrawalAllowed,
      depositAllowed,
      onlyPlayerCreationAllowed,
      semiAutomaticPayment,
    },
    input: {
      setSemiAutomaticPayment,
      setWithdrawalAllowed,
      setDepositAllowed,
      setOnlyPlayerCreationAllowed,
      changeCommission,
      changeValue,
      onSubmit,
      changeValueUsername,
      changeValueMultiple,
      openModal,
      closeModal,
    },
  };
};

export default useCreateAgent;
